module.exports = __webpack_public_path__ + "img/0Q3C0560_FoamcoreMatted_MockedUp.e2bc262f.jpg";